<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M21 20C21.5523 20 22 20.4477 22 21C22 21.5523 21.5523 22 21 22H3C2.44772 22 2 21.5523 2 21C2 20.4477 2.44772 20 3 20H21ZM6.29289 7.29289C6.89547 6.69032 7.90718 7.07233 7.99402 7.88637L8 8V16C8 16.8522 7.01449 17.2974 6.37747 16.7832L6.29289 16.7071L2.29289 12.7071C1.93241 12.3466 1.90468 11.7794 2.2097 11.3871L2.29289 11.2929L6.29289 7.29289ZM21 15C21.5523 15 22 15.4477 22 16C22 16.5523 21.5523 17 21 17H13C12.4477 17 12 16.5523 12 16C12 15.4477 12.4477 15 13 15H21ZM21 11C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H13C12.4477 13 12 12.5523 12 12C12 11.4477 12.4477 11 13 11H21ZM21 7C21.5523 7 22 7.44772 22 8C22 8.55228 21.5523 9 21 9H13C12.4477 9 12 8.55228 12 8C12 7.44772 12.4477 7 13 7H21ZM21 2C21.5523 2 22 2.44772 22 3C22 3.55228 21.5523 4 21 4H3C2.44772 4 2 3.55228 2 3C2 2.44772 2.44772 2 3 2H21Z"
    fill="currentColor"
  />
</svg>
